export const MIN_PASSWORD_LENGTH = 8;
export const CODE_LENGTH = 6;
export const APP_URL_DEV = "https://d3ijx9ifmbl0cw.cloudfront.net";

export const TAG_COLOR_LIST = [
  "red",
  "orange",
  "yellow",
  "lime",
  "green",
  "turquoise",
  "blue",
  "violet",
  "purple",
  "pink",
  "grey",
];

export const TIME_FRAMES = {
  day: "Day",
  week: "Week",
  month: "Month",
};

export const MEAL_TYPES = {
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  snacks: "Snacks",
};

export const MEAL_COLORS = {
  [MEAL_TYPES.breakfast]: "yellow",
  [MEAL_TYPES.lunch]: "green",
  [MEAL_TYPES.dinner]: "blue",
  [MEAL_TYPES.snacks]: "purple",
};

export const PLANS = {
  free: "free",
  premium: "premium",
  vip: "vip",
};

export const PLAN_PRICES = {
  [PLANS.free]: 0,
  [PLANS.premium]: 3,
  [PLANS.vip]: 0,
};

export const RECIPE_LIMIT = 15;

export const mimeMap = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  tiff: "image/tiff",
  webp: "image/webp",
  svg: "image/svg+xml",
  avif: "image/avif",
};
